const CATEGORY_ERROR_CODE = {
  CATEGORY_001: 'CATEGORY001',
  CATEGORY_002: 'CATEGORY002',
  CATEGORY_003: 'CATEGORY003',
  CATEGORY_004: 'CATEGORY004',
  CATEGORY_005: 'CATEGORY005',
  CATEGORY_006: 'CATEGORY006',
  CATEGORY_007: 'CATEGORY007',
  CATEGORY_008: 'CATEGORY008',
  CATEGORY_009: 'CATEGORY009',
  CATEGORY_010: 'CATEGORY010',
  CATEGORY_011: 'CATEGORY011',
  CATEGORY_012: 'CATEGORY012',
  CATEGORY_013: 'CATEGORY013',
  CATEGORY_014: 'CATEGORY014',
  CATEGORY_015: 'CATEGORY015',
  CATEGORY_016: 'CATEGORY016',
  CATEGORY_017: 'CATEGORY017',
  CATEGORY_018: 'CATEGORY018',
  CATEGORY_019: 'CATEGORY019',
  CATEGORY_020: 'CATEGORY020',
  CATEGORY_021: 'CATEGORY021',
  CATEGORY_022: 'CATEGORY022',
  CATEGORY_023: 'CATEGORY023',
  CATEGORY_024: 'CATEGORY024',
  CATEGORY_025: 'CATEGORY025',
  CATEGORY_026: 'CATEGORY026',
  CATEGORY_027: 'CATEGORY027',
  CATEGORY_028: 'CATEGORY028',
  CATEGORY_029: 'CATEGORY029',
  CATEGORY_030: 'CATEGORY030',
  CATEGORY_031: 'CATEGORY031',
  CATEGORY_032: 'CATEGORY032',
  CATEGORY_033: 'CATEGORY033',
  CATEGORY_034: 'CATEGORY034',
  CATEGORY_035: 'CATEGORY035',
  CATEGORY_036: 'CATEGORY036',
  CATEGORY_037: 'CATEGORY037',
  CATEGORY_038: 'CATEGORY038',
  CATEGORY_039: 'CATEGORY039',
  CATEGORY_040: 'CATEGORY040',
  CATEGORY_041: 'CATEGORY041',
  CATEGORY_042: 'CATEGORY042',
  CATEGORY_043: 'CATEGORY043',
  CATEGORY_044: 'CATEGORY044',
  CATEGORY_045: 'CATEGORY045',
  CATEGORY_046: 'CATEGORY046',
  CATEGORY_047: 'CATEGORY047',
  CATEGORY_048: 'CATEGORY048',
  CATEGORY_049: 'CATEGORY049',
  CATEGORY_050: 'CATEGORY050',
  CATEGORY_051: 'CATEGORY051',
  CATEGORY_052: 'CATEGORY052',
  CATEGORY_057: 'CATEGORY057',
  CATEGORY_058: 'CATEGORY058',
  CATEGORY_059: 'CATEGORY059',
  CATEGORY_060: 'CATEGORY060',
  CATEGORY_061: 'CATEGORY061',
  CATEGORY_062: 'CATEGORY062',
  CATEGORY_063: 'CATEGORY063',
  CATEGORY_064: 'CATEGORY064',
  CATEGORY_065: 'CATEGORY065',
  CATEGORY_066: 'CATEGORY066',
  CATEGORY_067: 'CATEGORY067',
  CATEGORY_068: 'CATEGORY068',
};

const CATEGORY_ERROR_MESSAGE = {
  [CATEGORY_ERROR_CODE.CATEGORY_001]: '카테고리 ID는 숫자만 가능 합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_002]: '카테고리 명칭은 최대 13자까지만 가능 합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_003]: '유효하지 않은 카테고리 타입 입니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_004]: '유효하지 않은 카테고리 상태 입니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_005]: '카테고리 전시 여부가 유효하지 않습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_006]: '카테고리 노출 타입이 유효하지 않습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_007]: '카테고리 정렬 타입이 유효하지 않습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_008]: '유효하지 않은 카테고리 고유 ID 입니다.\n새로고침 후 재 확인 부탁드립니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_009]: '카테고리 ID 에 해당하는 카테고리가 존재하지 않습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_010]: '서브 테스트는 최대 20자까지 입력 할 수 있습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_011]: 'subText 는 강조형 카테고리만 입력 가능합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_012]: 'subText 는 빈 문자열이 올 수 없습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_013]: '카테고리 생성 및 수정 사유 최대 1000자까지 입력 할 수 있습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_014]: '카테고리 생성 및 수정 사유는 빈 문자열이 올 수 없습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_015]: '카테고리명을 입력해주세요',
  [CATEGORY_ERROR_CODE.CATEGORY_016]: '이미 사용중인 명칭입니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_017]: '유효하지 않은 카테고리 version 입니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_018]: '1차 카테고리에 속한 2차 카테고리는 서로 동일한 명칭을 사용할 수 없습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_019]: '해당 카테고리 버전이 최신 버전이 아닙니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_020]:
    '해당 카테고리에만 연결된 상품이 있습니다. 해당 상품들의 카테고리 설정 변경 후 카테고리 비노출이 가능합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_021]: '수정하려는 2차 카테고리 중 1차 카테고리 id 가 존재합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_022]: '삭제하려는 2차 카테고리 중 1차 카테고리 id 가 존재합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_023]: '1차 카테고리 수정에 실패했습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_024]: '2차 카테고리 삭제에 실패했습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_025]: '2차 카테고리 수정에 실패했습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_026]:
    '전시중인 상태에서는 카테고리 사용 여부를 변경 할 수 없습니다.\n 전시 상태를 먼저 변경 부탁드립니다',
  [CATEGORY_ERROR_CODE.CATEGORY_027]: '카테고리 차수는 1, 2 만 가능합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_028]:
    '전시중인 상태에서는 카테고리 사용 여부를 변경 할 수 없습니다.\n 전시 상태를 먼저 변경 부탁드립니다',
  [CATEGORY_ERROR_CODE.CATEGORY_029]: 'categories 는 array 형태만 올 수 있습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_030]: '일반형 카테고리는 1개라도 전시 되어야 합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_031]: '동일한 카테고리 ID가 중복 설정 되어 있습니다. ',
  [CATEGORY_ERROR_CODE.CATEGORY_032]: '전시하려는 카테고리 중 존재하지 않는 카테고리 id 가 있습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_033]: '전시 카테고리 중 이름이 변경 된 카테고리 정보가 있습니다. 다시 확인해주세요.',
  [CATEGORY_ERROR_CODE.CATEGORY_034]:
    '해당 1차 카테고리를 메인으로 가지고있는 상품이 존재해 비활성 처리가 불가능합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_035]: '비활성 카테고리는 전시 할 수 없습니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_036]: '존재하지 않거나 비활성 카테고리입니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_037]: '카테고리 ID 는 필수값입니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_038]: '카테고리 ID는 숫자만 입력 가능합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_039]: '1차 카테고리 비활성 상태입니다.\n새로고침 후 재 확인 부탁드립니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_040]: '유효하지 않은 2차 카테고리 ID 입니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_041]: '존재하지 않는 1차 카테고리 입니다.\n새로고침 후 재 확인 부탁드립니다',
  [CATEGORY_ERROR_CODE.CATEGORY_042]: '존재하지 않는 2차 카테고리 입니다',
  [CATEGORY_ERROR_CODE.CATEGORY_043]: '상품이 등록 된 상태에서는 카테고리 삭제 불가 합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_044]: '2차 카테고리가 전시중 입니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_045]: '공백만 입력 불가합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_046]: '카테고리명을 입력해주세요',
  [CATEGORY_ERROR_CODE.CATEGORY_047]: '카테고리 상태값을 확인해주세요',
  [CATEGORY_ERROR_CODE.CATEGORY_048]: '카테고리 삭제는 최대 100개 까지만 가능 합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_049]: '반지, 목걸이, 귀걸이, 팔찌, 발찌, 이어커프 카테고리는 삭제 불가능합니다',
  [CATEGORY_ERROR_CODE.CATEGORY_050]: '상품이 등록 된 상태에서는 카테고리 삭제 불가 합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_051]: '전시 상태에서는 카테고리 삭제 불가 합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_052]: '네트워크 오류가 발생 되었습니다. 개발팀에게 문의해주세요',
  [CATEGORY_ERROR_CODE.CATEGORY_057]: '네트워크 오류가 발생 되었습니다. 개발팀에게 문의해주세요',
  [CATEGORY_ERROR_CODE.CATEGORY_058]: '1MB 이상의 이미지는 등록 불가합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_059]: 'png, jpg, jpeg 형식의 이미지만 등록 가능합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_060]: '정방형 이미지만 업로드가 가능합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_061]: '권장 크기(216 X 216 픽셀)보다 작은 이미지는 등록 불가 합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_062]: '네트워크 오류가 발생 되었습니다. 개발팀에게 문의해주세요',
  [CATEGORY_ERROR_CODE.CATEGORY_063]: '네트워크 오류가 발생 되었습니다. 개발팀에게 문의해주세요',
  [CATEGORY_ERROR_CODE.CATEGORY_064]: '네트워크 오류가 발생 되었습니다. 개발팀에게 문의해주세요',
  [CATEGORY_ERROR_CODE.CATEGORY_065]: '네트워크 오류가 발생 되었습니다. 개발팀에게 문의해주세요',
  [CATEGORY_ERROR_CODE.CATEGORY_066]: '카테고리명은 한글, 영어, 숫자, 공백, 특수문자만 입력 가능합니다',
  [CATEGORY_ERROR_CODE.CATEGORY_067]: '강조형 1차 카테고리명은 최대 8자까지 입력 가능 합니다.',
  [CATEGORY_ERROR_CODE.CATEGORY_068]: '일반형 1차 카테고리명은 최대 11자까지 입력 가능 합니다.',
};

export default CATEGORY_ERROR_MESSAGE;
